import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import MetaPixel from './components/MetaPixel';
export function AppRouter() {
  return <BrowserRouter data-id="element-14">
      <MetaPixel data-id="element-15" />
      <Routes data-id="element-16">
        <Route path="/" element={<App data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}